module.exports = __webpack_public_path__ + "img/cncj_1.e2140c66.jpg";